import FlightDetails from './FlightDetails';
import TrainDetails from './TrainDetails';
import BusDetails from './BusDetails';
import DefaultDetails from './DefaultDetails';

// Registry of travel type components
const TYPE_COMPONENTS = {
    flight: FlightDetails,
    train: TrainDetails,
    bus: BusDetails,
    // Add more as they're implemented
    // cruise: CruiseDetails,
    // etc.
};

/**
 * Gets the appropriate component for a travel type
 * @param {string} type - The travel type
 * @returns {React.ComponentType} - The component to render for this type
 */
export const getTypeComponent = (type) => {
    return TYPE_COMPONENTS[type] || DefaultDetails;
};

export {
  FlightDetails,
  TrainDetails,
  BusDetails,
  DefaultDetails
}; 